import React from "react";
import {Row, Col, InputGroup } from 'react-bootstrap';

import ModalComponent from "../components/ModalComponent";
import ItemNamePartialComponent from '../partials/ItemNamePartialComponent';
import DownloadButtonPartial from "./DownloadButtonPartial";

const PreSchoolEduItemsPartial = ({data = null, params = [], selectedSeries = [], selectedLevels = [], selectedVolumes = [], selectedTags = [], showOnlyMy = false}) => {

  let response = data; 
  if(selectedSeries.length > 0 && response != null){
    response = response.filter(item => {
      return item.series.some(seriesItem => {
        return selectedSeries.some(filterItem => filterItem.value === seriesItem.slug) && (selectedLevels.length === 0 || selectedLevels.some(filterItem => filterItem.value === seriesItem.age));
      });
    });

    if(Object.keys(response).length > 0 && Object.keys(selectedVolumes).length > 0){
      response = response.filter(item => {
        return item.volumes.some(volumesItem => {
          return selectedVolumes.some(filterItem => filterItem.value === volumesItem.slug) && (selectedLevels.length === 0 || selectedLevels.some(filterItem => filterItem.value === volumesItem.name));
        });
      });
    }
  }

  if (selectedTags.length > 0 && response != null) {
    response = response.filter(item => {
      return selectedTags.some((tag) => item.tags.includes(tag));
    })
  }

  return(
    <React.Fragment>
      
      <Row className="p-0 mb-3">
        <Col xs={12} md={6} lg={6} className="p-0">
       

          
        </Col>
        <Col xs={12} md={6} lg={6}>
          <p className="searchCounter">Liczba znalezionych pozycji: <strong>{response.length}</strong></p>
        </Col>
      </Row>
      
      {
         Object.keys(response).length === 0 ? <p>Brak treści do wyświetlenia</p> : response.map((item, key) => {
          let modal;
          let download;
          let fileSize = "ZIP";

          console.log(item.download + " - " + Object.keys(item.download).length + " - " +  item.categories.at(0))

          if(item.download !== undefined && Object.keys(item.download).length > 0 && item.categories.at(0) !== undefined){
            modal = <ModalComponent item={item} link={"/"+params.language+"/"+item.categories.at(0).slug+"/"+item.slug+","+item.kId} language={params.language} />
            download = <DownloadButtonPartial item={item} language={params.language}/>
          }

          if(item.download.files.length === 1){
            fileSize = item.download.files[0].ext + " ("+item.download.files[0].bytes+")";
          }

          return(
            <Row key={key} className="p-3 kb-item">
              <Col sm={12} md={7} lg={7} className="title"><ItemNamePartialComponent item={item} /></Col>
              <Col sm={12} md={2} lg={2} className="file-size"><small>{fileSize}</small></Col>
              <Col sm={6} md={2} lg={2} className="button"><div className="d-grid gap-2">{modal}</div></Col>
              <Col sm={6} md={1} lg={1} className="button"><div className="d-grid gap-2">{download}</div></Col>
            </Row>
          );
        })
      }

    </React.Fragment>
  )

}
export default PreSchoolEduItemsPartial;